module.exports = __webpack_public_path__ + "static/warren-buffett-b38f87df9253a9a7dc5ba2899ce13929.jpg";